import { Button, Result, Spin } from 'antd';
import { Navigate, Route, Routes } from 'react-router';
import { useMe } from './api/auth';
import { ApiError } from './api/client';
import { AppShell } from './components/AppShell';
import { CashflowPage } from './pages/CashflowPage';
import { ConnectionsPage } from './pages/ConnectionsPage';
import { ExportPage } from './pages/ExportPage';
import { InvoicesPage } from './pages/InvoicesPage';
import { LoginPage } from './pages/LoginPage';
import { OverviewPage } from './pages/OverviewPage';
import { ReconPage } from './pages/ReconPage';

export function App() {
  const me = useMe();

  if (me.isPending) return <Spin fullscreen size="large" />;
  if (me.error) {
    if (me.error instanceof ApiError && me.error.code === 'UNAUTHENTICATED') return <LoginPage />;
    return (
      <Result
        status="error"
        title="Không kết nối được máy chủ"
        subTitle={me.error.message}
        extra={<Button onClick={() => void me.refetch()}>Thử lại</Button>}
      />
    );
  }

  return (
    <AppShell me={me.data}>
      <Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/hoa-don" element={<InvoicesPage />} />
        <Route path="/doi-soat" element={<ReconPage />} />
        <Route path="/dong-tien" element={<CashflowPage />} />
        <Route path="/xuat-file" element={<ExportPage />} />
        <Route path="/ket-noi" element={<ConnectionsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
